function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "Check_svg__44_a"
}, React.createElement("stop", {
  stopColor: "#4EDC9F",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#1DC463",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 1a8 8 0 017.996 7.75L17 9a8 8 0 01-7.75 7.996L9 17A8 8 0 019 1zm3.292 4.198a.682.682 0 00-.078.087l-4.617 6.13-1.746-2.25a.756.756 0 00-1.096-.092.657.657 0 00-.061.89l2.015 2.608c.343.455 1.018.566 1.509.248.104-.068.194-.152.267-.248l4.886-6.488a.657.657 0 00-.061-.89.76.76 0 00-1.018.005z",
  transform: "translate(-1 -1)",
  fill: "url(#Check_svg__44_a)",
  fillRule: "evenodd"
});

var SvgCheck = function SvgCheck(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
};

export default SvgCheck;